import { NgModule } from "@angular/core";
import { SharedModule } from "@shared/shared.module";
import { ActiveConsultationComponent, ConsultationsComponent, ConsultationsService, ViewConsultationComponent } from "./";
import { FormsModule } from "@angular/forms";

@NgModule({
    declarations: [ConsultationsComponent, ViewConsultationComponent, ActiveConsultationComponent],
    imports: [SharedModule, FormsModule],
    providers: [ConsultationsService],
})
export class ConsultationsModule {}
